import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PayBillingActions = createActionGroup({
    source: 'Margin Calculator - Pay Billing',
    events: {
        revealPayBillingDetailsClicked: emptyProps(),
        revealStipendDetailsClicked: emptyProps(),
        setMarginPayRate: props<{ payRate: number }>(),
        setPremiumRate: props<{ payRate: number }>(),
        setOvertimeRate: props<{ overTimeRate: number }>(),
        setOvertimeRateAlt: props<{ overTimeRateAlt: number }>(),
        setTaxableStipend: props<{ taxableStipend: number }>(),
        setCalculatedStipendValues: props<{
            mealStipend: number;
            housingStipend: number;
            weeklyStipends: number;
        }>(),
        setMealStipend: props<{ mealStipend: number }>(),
        setMealStipendAndRelatedValues: props<{
            mealStipend: number;
            mealStipendPerShift: number;
            mealStipendPerDay: number;
            weeklyStipends: number;
        }>(),
        setHousingStipend: props<{ housingStipend: number }>(),
        setHousingStipendAndRelatedValues: props<{
            housingStipend: number;
            housingStipendPerShift: number;
            housingStipendPerDay: number;
            weeklyStipends: number;
        }>(),
        setStipendsPerContract: props<{ stipendsPerContract: number }>(),
        setMaxMeal: props<{ maxMeals: number }>(),
        setMaxHousing: props<{ maxHousing: number }>(),
        setMaxStipends: props<{ maxStipends: number }>(),
        setWeeklyStipends: props<{ weeklyStipends: number }>(),
        setBlendedPayRate: props<{ payRate: number }>(),
        setOtBillingRulesEnabled: props<{ isBillOverTime: boolean }>(),
        setMinPremiumPayRates: props<{ rate: number }>(),
        setMinPremiumPayRateOnly: props<{ rate: number }>(),
        setShiftBonus: props<{ shiftBonus: number }>(),
        overtimeRulesChanged: props<{
            overtimeHours: number;
            billDailyOtAfter: number;
            billDorW: string;
            billDorWM: string;
            andOr: string;
        }>(),
        earlyPaymentDiscountChanged: props<{ discountPercent: number }>(),
        setContractFees: props<{ contractFees: number }>(),
        holidayPayRateChanged: props<{ holidayPayRate: number }>(),
        holidayBillRateChanged: props<{ holidayBillRate: number }>(),
        onCallPayRateChanged: props<{ onCallPayRate: number }>(),
        onCallBillRateChanged: props<{ onCallBillRate: number }>(),
        callbackPayRateChanged: props<{ callbackPayRate: number }>(),
        callbackBillRateChanged: props<{ callbackBillRate: number }>(),
        chargePayRateChanged: props<{ chargePayRate: number }>(),
        chargeBillRateChanged: props<{ chargeBillRate: number }>(),
        recalculateOnCallPayRateSuccess: props<{ onCallPayRate: number; marginOnCallPayRate: number }>(),
        setDefaultOnCallPayRateValueSuccess: emptyProps(),
        recalculateOnCallBillRateSuccess: props<{ onCallBillRate: number }>(),
        recalculateChargePayRateSuccess: props<{ chargePayRate: number; marginChargePayRate: number }>(),
        setDefaultChargePayRateValueSuccess: emptyProps(),
        recalculateChargeBillRateSuccess: props<{ chargeBillRate: number }>(),
        setDefaultHolidayBillRateValidatorSuccess: emptyProps(),
        recalculateHolidayBillRateSuccess: props<{ holidayBillRate: number }>(),
        setDefaultCallbackBillRateValidatorSuccess: emptyProps(),
        recalculateCallbackBillRateSuccess: props<{ callbackBillRate: number }>(),
        holidayCallbackPayRateChanged: props<{ holidayPayRate: number; callbackPayRate: number }>(),
        extDiscountChanged: props<{ extDiscount: number }>(),
        setCallbackIncluded: props<{ callbackPayRateIncluded: boolean }>()
    }
});
